import React from 'react'
import { Link } from 'gatsby'

import {
  Layout,
  Showcase,
  SectionTitle,
  Header,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  const showMenu = () =>
    document.getElementById('dropDownMenu').classList.toggle('u-display--block')

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            The object card is now the account card patterns. To use an actions
            variant of the account card, visit the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-action/develop'}
            >
              Account Card - Actions
            </Link>{' '}
            page . To use an input variant, see the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-checkbox/develop'}
            >
              {' '}
              Account Card - Checkbox
            </Link>
            ,{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-radio/develop'}
            >
              Account Card - Radio
            </Link>{' '}
            or the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/patterns/account-card-select/develop'}
            >
              Account Card - Select
            </Link>{' '}
            pages.
          </p>
        </Intro>
        {/* <Intro>
          <p>
            Object cards are used to list repeatable, related content, such as
            user accounts or addresses, where each card represents a discrete
            object. They are intended to create discernable visual patterns that
            are quickly recognized, so they should only represent one type of
            information within an experience. Object cards often appear in
            collections and should follow the same internal structure so they
            are easily scanned.
          </p>
        </Intro>

        <SectionTitle>Variants</SectionTitle>
        <Showcase
          full={true}
          site={data.site}
          title="Actions"
          text="Use this variant to display 1-3 actions associated with the information on the card as interactive icons with a label. Actions are always optional. The actions variant can also display an inline notification to give user feedback. If the notification is the only content within the obeject card, use it without a border."
          code={code.Action}
        >
          <div className="negative-margin-wrapper">
            <div className="c-card__border-top u-flex-container u-flex-wrap--wrap">
              <div className="c-card__body--small u-flex-wrap--wrap">
                <div>
                  <a href="#" className="c-card__title--actionable">
                    Ruby McAdio
                    <i className="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                  </a>
                </div>
                <div className="u-display--inline-block l-margin-right--large">
                  <div className="c-title-2--normal">
                    6623 Forest Ave. KCMO 64112
                  </div>
                  <div className="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                    Add delivery instructions
                  </div>
                  <a
                    href="#"
                    className="c-icon-link u-type--xsmall u-display--inline"
                  >
                    <i className="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                    What's this?
                  </a>
                </div>
              </div>
              <ul className="c-horizontal-list">
                <li className="c-horizontal-list__item">
                  <a href="#" className="c-horizontal-list__link">
                    <i className="c-horizontal-list__icon icon icon--pencil"></i>
                    <span className="c-horizontal-list__text">
                      Edit address
                    </span>
                  </a>
                </li>
                <li className="c-horizontal-list__item">
                  <a href="#" className="c-horizontal-list__link">
                    <i className="c-horizontal-list__icon icon icon--trash-can"></i>
                    <span className="c-horizontal-list__text">
                      Delete address
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="c-card__border-top u-flex-container u-flex-wrap--wrap">
              <div className="c-card__body--small u-flex-wrap--wrap">
                <div>
                  <a href="#" className="c-card__title--actionable">
                    Luther Bonadam
                    <i className="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                  </a>
                </div>
                <div className="u-display--inline-block l-margin-right--large">
                  <div className="c-title-2--normal">
                    357 Alexander St. Rochester, NY 14607
                  </div>

                  <div className="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                    Add delivery instructions
                  </div>
                  <a
                    href="#"
                    className="c-icon-link u-type--xsmall u-display--inline"
                  >
                    <i className="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                    What's this?
                  </a>
                </div>
              </div>
              <ul className="c-horizontal-list">
                <li className="c-horizontal-list__item">
                  <a href="#" className="c-horizontal-list__link">
                    <i className="c-horizontal-list__icon icon icon--pencil"></i>
                    <span className="c-horizontal-list__text">
                      Edit address
                    </span>
                  </a>
                </li>
                <li className="c-horizontal-list__item">
                  <a href="#" className="c-horizontal-list__link">
                    <i className="c-horizontal-list__icon icon icon--trash-can"></i>
                    <span className="c-horizontal-list__text">
                      Delete address
                    </span>
                  </a>
                </li>
              </ul>
              <div className="c-notification--inline-error l-margin--small">
                <div className="c-notification__icon">
                  <i className="icon icon--exclamation"></i>
                </div>
                <div className="c-notification__content">
                  We weren't able to verify this address.
                </div>
              </div>
            </div>
          </div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Select"
          text="Use this variant to gather user input. The user can select a single object from a dropdown list of options. The entire container of the select object card is a hit area that triggers the dropdown. Do not use any other interactive components in a selected state."
          code={code.Select}
        >
          <div className="c-card__border-top">
            <div className="c-drop-down">
              <div className="c-drop-down__field">
                <div className="c-drop-down__content">
                  <div className="u-display--inline-block l-margin-right--large">
                    <div className="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an object
                    </div>
                    <div className="c-caption--normal">
                      Expand to see a list of available objects
                    </div>
                  </div>
                </div>
                <button
                  className="c-drop-down__toggle"
                  id="dropDownToggle"
                  onClick={() => showMenu()}
                >
                  <i className="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
              <div className="c-drop-down__menu" id="dropDownMenu">
                <a href="#" className="c-drop-down__menu-item">
                  <span className="c-drop-down__menu-item-main">
                    Object 1 <span className="u-type--xsmall">...subtitle</span>
                  </span>
                  <span className="c-drop-down__menu-item-alt">Context</span>
                </a>
                <a href="#" className="c-drop-down__menu-item">
                  <span className="c-drop-down__menu-item-main">
                    Object 2 <span className="u-type--xsmall">...subtitle</span>
                  </span>
                  <span className="c-drop-down__menu-item-alt">Context</span>
                </a>
                <a href="#" className="c-drop-down__menu-item">
                  <span className="c-drop-down__menu-item-main">
                    Object 3 <span className="u-type--xsmall">...subtitle</span>
                  </span>
                  <span className="c-drop-down__menu-item-alt">Context</span>
                </a>
              </div>
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>The select variant has both an empty state and an active state.</p>
        <Showcase
          site={data.site}
          title="Empty"
          text="Instead of displaying object information, the empty state uses a title and subtitle to invite the user to make a selection."
        >
          <div className="c-card__border-top">
            <div className="c-drop-down">
              <div className="c-drop-down__field">
                <div className="c-drop-down__content">
                  <div className="u-display--inline-block l-margin-right--large">
                    <div className="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an object
                    </div>
                    <div className="c-caption--normal">
                      Expand to see a list of available objects
                    </div>
                  </div>
                </div>
                <button className="c-drop-down__toggle" id="dropDownToggle">
                  <i className="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Active"
          text="In the active state, a dropdown presents input options with their own hover states, represented by a green bar. There is currently no limit on the number of objects shown in the dropdown. If the options extend off the screen, the dropdown container should stop and scroll within."
        >
          <div className="c-card__border-top">
            <div className="c-drop-down">
              <div className="c-drop-down__field">
                <div className="c-drop-down__content">
                  <div className="u-display--inline-block l-margin-right--large">
                    <div className="c-title-2--normal u-color--primary-base u-type--bold">
                      Select an object
                    </div>
                    <div className="c-caption--normal">
                      Expand to see a list of available objects
                    </div>
                  </div>
                </div>
                <button className="c-drop-down__toggle" id="dropDownToggle">
                  <i className="icon icon--arrow-without-tail-down"></i>
                </button>
              </div>
              <div className="c-drop-down__menu u-display--block">
                <button className="c-drop-down__menu-item">
                  <span className="c-drop-down__menu-item-main">
                    Object 1 <span className="u-type--xsmall">...subtitle</span>
                  </span>
                  <span className="c-drop-down__menu-item-alt">Context</span>
                </button>
                <button className="c-drop-down__menu-item">
                  <span className="c-drop-down__menu-item-main">
                    Object 2 <span className="u-type--xsmall">...subtitle</span>
                  </span>
                  <span className="c-drop-down__menu-item-alt">Context</span>
                </button>
                <button className="c-drop-down__menu-item">
                  <span className="c-drop-down__menu-item-main">
                    Object 3 <span className="u-type--xsmall">...subtitle</span>
                  </span>
                  <span className="c-drop-down__menu-item-alt">Context</span>
                </button>
              </div>
            </div>
          </div>
        </Showcase>
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Object cards are designed to stack vertically. To reflect their visual
          pattern and enhance scannability, always place them on a fixed grid.
        </p>
        <p>
          At smaller breakpoints, the action variant will responsively list the
          available actions at the bottom of the card. To optimize touch
          interactions likely at these breakpoints, the select variant will
          trigger a full-screen modal that lists each available option as a
          populated object card instead of triggering a dropdown. Selecting an
          object within the list will exit the modal and bring the user back to
          the initial screen.
        </p>
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Action labels should use strong verbs and specific language, similar
          to{' '}
          <Link class="link" to={'/' + data.site + '/components/button/design'}>
            buttons
          </Link>{' '}
          . The empty state title and subtitle for the select variation should
          be simple CTAs, such as "Select a(n) [object]" and "Expand to see a
          list of available [objects]". Otherwise, follow the microcopy
          guidelines for the{' '}
          <Link class="link" to={'/' + data.site + '/components/link/design'}>
            icon links
          </Link>{' '}
          and{' '}
          <Link class="link" to={'/' + data.site + '/components/label/design'}>
            label
          </Link>{' '}
          components.
        </p> */}
      </Layout>
    </>
  )
}

export const code = {
  Action: `
  <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
            <div class="c-card__body--small u-flex-wrap--wrap">
              <div>
                <a href="#" class="c-card__title--actionable">
                  Luther Bonadam
                  <i class="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                </a>
              </div>
              <div class="u-display--inline-block l-margin-right--large">
                <div class="c-title-2--normal">
                  357 Alexander St. Rochester, NY 14607
                </div>

                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Add delivery instructions
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
            </div>
            <ul class="c-horizontal-list">
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--pencil"></i>
                  <span class="c-horizontal-list__text">Edit address</span>
                </a>
              </li>
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--trash-can"></i>
                  <span class="c-horizontal-list__text">Delete address</span>
                </a>
              </li>
            </ul>
          </div>
`,
  Select: `
  <div class="c-card__border-top">
  <div class="c-card__body--small l-padding-bottom--none">
    <a href="#" class="c-card__title--actionable">EZChoice Checking <span class="c-card__title-sub">....555356</span><i class='c-card__title--actionable-icon icon icon--arrow-without-tail-right'></i></a>
  </div>
  <div class="c-drop-down">
    <!-- Custom Content -->
    <div class="c-drop-down__field">
      <div class="c-drop-down__content">
        <div class="u-display--inline-block l-margin-right--large">
          <div class="c-title-2--normal"><sup class="u-type--small">$</sup>1,000.00</div>
          <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">Balance Label</div> 
          <a href="" class="c-icon-link u-type--xsmall u-display--inline">
            <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>What's this?
          </a>
        </div>
        <div class="u-display--inline-block">
          <div class="c-title-2--normal"><span class="u-type--medium">$1,000.00</span> <span class="u-type--xsmall">due on 12/31/20</span></div>
          <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">Balance Label</div> 
          <a href="" class="c-icon-link u-type--xsmall u-display--inline">
            <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>What's this?
          </a>
        </div>
      </div> <!-- /dropdown content-->
      <button class="c-drop-down__toggle" id="dropDownToggle"><i class="icon icon--arrow-without-tail-down"></i></button>
    </div>
    <div class="c-drop-down__menu" id="dropDownMenu">
      <a href="#" class="c-drop-down__menu-item">
        <span class="c-drop-down__menu-item-main">EZChoice Checking <span class="u-type--xsmall">....555356</span></span> 
        <span class="c-drop-down__menu-item-alt">$1,000.00</span></a>
      </a>
      <button  class="c-drop-down__menu-item">
        <span class="c-drop-down__menu-item-main">EZChoice Checking <span class="u-type--xsmall">....555356</span></span> 
        <span class="c-drop-down__menu-item-alt">$1,000.00</span></a>
      </button>
      <a href="#" class="c-drop-down__menu-item">
        <span class="c-drop-down__menu-item-main">EZChoice Checking <span class="u-type--xsmall">....555356</span></span> 
        <span class="c-drop-down__menu-item-alt">$1,000.00</span></a>
      </a>
    </div>
    </div>
</div>
`,
}
